import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CfetBaseComponent, ErrorService } from '../../../cfet-core';

@Component({
    selector: 'app-customer-documents-upload',
    templateUrl: './customer-documents-upload.component.html',
    styleUrls: ['./customer-documents-upload.component.scss'],
    standalone: false
})

export class CustomerDocumentsUploadComponent extends CfetBaseComponent implements OnInit {
  public openModal = '';
  hideDocuploadSection = false;
  docUploadAccordioanModal = false;
  showIDAccordion = true;
  showPayAccordion = true;
  showCertAccordion = true;
  showSignedAccordion = true;
  showUploadButton = true;
  disabledUploadingButton = false;
  hideUploadButton = false;
  disableSkipButton = false;
  showUploadingButton = false;
  showDoneButton = false;
  accModalClicked = false;
  deleteModalClicked = false;
  skipModalClicked = false;
  openDocUploadModal = '';
  openFileDeleteModal = '';
  openSkipFileUploadModal = '';
  OpenEmployeeBadge = false;
  OpenEmployeePay = false;
  OpenCertification = false;
  OpenSignedLetter = false;
  isEmpVolID = false;
  isEmpPay = false;
  isCert = false;
  isSignedLetter = false;
  fileNameSplit: any;
  splitFileName: any;
  selectedOrg: any;
  fileName: string;
  fileSizeError = false;
  fileExtnError = false;
  fileUpload = true;
  fileUploaded = false;
  localUrl: any[];
  url: any;
  file: File;
  fileList = [];
  imagePath: any[];
  currentStepData: any;
  getFileExt: any;
  ind: any;
  selectedFile: any;
  validfiletype: boolean;
  docsAllowed: any;
  errorMessage: any;
  geteligibilityInfo: any;
  entity: any;
  type: any;
  jobfunction: any;

  @Input() selectedWorkPlace: string;
  @Input() fname: string;
  @Input() lname: string;
  @Output() goToDocReceived = new EventEmitter<any>();
  @ViewChild('attachments') attachment: any;

  constructor(private errorService: ErrorService) { super(); }

  ngOnInit () {
    window.scrollTo(0, 0);
    this.errorService.showError.next(false);
    // Getting session data for currentStepData 
    if (sessionStorage.getItem('ngStorage-currentStepData')) {
      this.currentStepData = JSON.parse(sessionStorage.getItem('ngStorage-currentStepData'));
    }
    // Getting session data for eligibilityInfo
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.geteligibilityInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.jobfunction = this.geteligibilityInfo.selectedRoleVal;
      this.entity = this.geteligibilityInfo.entity;
      this.type = this.geteligibilityInfo.type;
      this.docsAllowed = this.geteligibilityInfo.documents;
      // id-badge,paystub,signedletter,emscert
      this.showIDAccordion = this.docsAllowed && this.docsAllowed.indexOf('id-badge') > -1;
      this.showPayAccordion = this.docsAllowed && this.docsAllowed.indexOf('paystub') > -1;
      this.showSignedAccordion = this.docsAllowed && this.docsAllowed.indexOf('signedletter') > -1;
      this.showCertAccordion = this.docsAllowed && this.docsAllowed.indexOf('emscert') > -1;

      if (this.docsAllowed === undefined || this.docsAllowed.length === 0) {
        this.showCertAccordion = true;
        this.showIDAccordion = true;
        this.showPayAccordion = true;
        this.showSignedAccordion = true;
      }
    }
  }

  onFileChange (event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.showUploadButton = false;
      this.showUploadingButton = true;
      this.disableSkipButton = true;
      this.openSkipFileUploadModal = 'close';

      // Progress bar loader
      setTimeout(() => {
        this.progressBarLoading();
      }, 500);

      const reader = new FileReader();
      reader.onload = (fileEvent: any) => {
        this.url = fileEvent.target.result;
      };
      this.file = event.target.files[0];
      reader.readAsDataURL(this.file);
      // Delay the file upload process
      setTimeout(() => {
        if (this.file) {
          this.fileList.push({
            'file': this.file, 'imageurl': this.url
          });
          this.showDoneButton = true;
          this.fileUploaded = true;
          this.fileUpload = false;
          this.showUploadButton = true;
          this.fileName = this.file.name;
          this.showUploadingButton = false;
          if (this.fileList.length > 2) {
            this.showUploadButton = false;
            this.hideUploadButton = true;
          }
        }
      }, 2000);
    }
    this.attachment.nativeElement.value = '';
  }

  elementInViewport (el) {
    const elinfo = {
      'top': el.offsetTop,
      'height': el.offsetHeight,
    };
    if (elinfo.top + elinfo.height < window.screenY || elinfo.top > window.screenY + window.innerHeight) {
      return false;
    } else {
      return true;
    }
  }

  progressBarLoading () {
    const elem = document.getElementById('progressBar') as HTMLInputElement;
    let width = 1;
    const id = setInterval(frame, 10);
    function frame () {
      if (width >= 100) {
        clearInterval(id);
      } else {
        width++;
        elem.style.width = width + '%';
      }
    }
  }

  skipUpload (event: any) {
    if ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) && !this.disableSkipButton) {
      this.openSkipFileUploadModal = 'open';
      this.skipModalClicked = true;
    }
  }

  removeSelectedFile (index: any, event: any, fileName) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.ind = index;
      this.selectedFile = fileName;
      this.openFileDeleteModal = 'open';
      this.deleteModalClicked = true;
    }
  }

  goToModal (userClicked) {
    this.accModalClicked = true;
    window.scrollTo(0, 0);
    this.selectedOrg = this.selectedWorkPlace;
    if (userClicked === 'ID') {
      this.isEmpVolID = true;
      this.isEmpPay = false;
      this.isCert = false;
      this.isSignedLetter = false;
    } else if (userClicked === 'EmpPay') {
      this.isEmpPay = true;
      this.isEmpVolID = false;
      this.isCert = false;
      this.isSignedLetter = false;
    } else if (userClicked === 'Certificate') {
      this.isCert = true;
      this.isEmpVolID = false;
      this.isEmpPay = false;
      this.isSignedLetter = false;
    } else if (userClicked === 'SignedLetter') {
      this.isSignedLetter = true;
      this.isCert = false;
      this.isEmpPay = false;
      this.isEmpVolID = false;
    }
    this.removeError();
    this.hideDocuploadSection = true;
    this.docUploadAccordioanModal = true;
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.docUploadAccordioanModal = false;
      window.scrollTo(0, 0);
      this.OpenEmployeeBadge = false;
      this.OpenEmployeePay = false;
      this.OpenCertification = false;
      this.OpenSignedLetter = false;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)) {
        document.getElementById('progress-tracker').setAttribute('style', 'display:block');
        document.getElementsByClassName('customer_facing_header')[0].setAttribute('style', 'display:block');
        document.getElementById('footer-container').setAttribute('style', 'display:block');
      }
    }
  }

  closeDeleteFileModal (event) {
    if (event === 'modalClose') {
      this.openFileDeleteModal = 'close';
    } else if (event === 'DeleteFile') {
      if (this.ind !== -1) {
        this.fileList.splice(this.ind, 1);
        if (this.fileList.length < 3) {
          this.showUploadButton = true;
          // Flag for styling
          this.hideUploadButton = false;
        }
      }
    }
    // If all the files are removed
    if (this.fileList.length === 0) {
      this.fileUploaded = false;
      this.fileUpload = true;
      this.showUploadButton = true;
      this.showUploadingButton = false;
      this.showDoneButton = false;
      this.hideUploadButton = false;
      this.disableSkipButton = false;
    }
  }

  closeSkipFileUploadModal (event) {
    if (event === 'modalClose') {
      this.openSkipFileUploadModal = 'close';
    }
  }

  removeError () {
    this.errorService.showError.next(false);
  }

  done (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // To spilt the filename
      this.checkFileType();
      if (this.validfiletype) {
        if (this.currentStepData && this.currentStepData.currentStep === 'docUpload') {
          let currentStepData = this.currentStepData;
          const docUploadurl = this.currentStepData.submissionUrl;
          const docUploadxhr = new XMLHttpRequest();
          const docUploadrequestParam = new FormData();
          for (const element of this.fileList) {
            docUploadrequestParam.append('file', element.file);
          }
          docUploadxhr.open('POST', docUploadurl);
          docUploadxhr.send(docUploadrequestParam);
          docUploadxhr.onreadystatechange = function () {
            this.checkError(docUploadxhr, currentStepData);
          }.bind(this, docUploadxhr);
        } else if (this.currentStepData && this.currentStepData.currentStep === 'pending') {
          // To make the session data to null
          this.currentStepData = {};
          sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(this.currentStepData));
          this.goToDocReceived.emit(true);
        }
      } else {
        // show File Type Error
        // a page level invalid file type error message should be shown
        const messageArray = [];
        messageArray.push(this.cfetMessages.off_doc_file_error, this.cfetMessages.off_doc_file_error_desc);
        this.errorService.displayErrorMessageList(messageArray);
        // empty the list
        this.fileList = [];
        this.fileUploaded = false;
        this.fileUpload = true;
        this.showUploadButton = true;
        this.showDoneButton = false;
        this.hideUploadButton = false;
        window.scrollTo(0, 0);
      }
    }
  }

  setErrorBasedOnDocUploadResponse (docuploadresponse) {
    if (docuploadresponse.errorIds && docuploadresponse.errorIds.length > 0) {
      this.errorMessage = docuploadresponse.errorIds[0];
    }
  }

  checkError (docUploadxhr, currentStepData) {
    let docuploadresponse: any;
    if (docUploadxhr.response && docUploadxhr.readyState === 4 && docUploadxhr.status === 200) {
      // To execute incase of no error - Show confirmation page
      docuploadresponse = JSON.parse(docUploadxhr.response);
      currentStepData.currentStep = docuploadresponse.currentStep;
      this.setErrorBasedOnDocUploadResponse(docuploadresponse);
      // To make the session data to null
      currentStepData = {};
      sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(currentStepData));
      if (docuploadresponse.errorIds && docuploadresponse.errorIds.length > 0) {
        this.errorMessage = docuploadresponse.errorIds[0];
      } else {
        this.goToDocReceived.emit(true);
      }
    }
  }

  checkFileType () {
    for (const element of this.fileList) {
      // To check whether the file is all these format or not
      this.fileNameSplit = element.file.name;
      // splitting the filename by dot symbol
      this.splitFileName = element.file.name.substr((this.fileNameSplit.lastIndexOf('.') + 1));
      // Getting the extension of a file required
      this.getFileExt = this.splitFileName.toLowerCase();
      // set validfiletype to true based on the extension
      if ((this.getFileExt === 'pdf' || this.getFileExt === 'png' || this.getFileExt === 'jpg' ||
        this.getFileExt === 'jpeg' || this.getFileExt === 'gif' || this.getFileExt === 'bmp')
        && (Math.floor(element.file.size / 1000) < 10000)) {
        this.validfiletype = true;
      } else {
        this.validfiletype = false;
        break;
      }
    }
  }
}
